import { Loading } from 'element-ui'

let loading = null
const showLoading = (params) => {
    if(loading) {
        loading.close()
    }
    let options = {
        fullscreen: false,
        target: document.querySelector('#mainLoad'),
        lock: true,
        text: '加载中',
        pinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
    }
    Object.assign(
        options,
        params
    )
    loading = Loading.service(options)
}
const hideLoading = () => {
	setTimeout(function(){
		loading.close()
	},1)
}
export {
    showLoading,
    hideLoading
}
